var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyLogoBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 268,
    viewBox: "0 0 266 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.152 154.176V176.087C175.152 194.563 157.92 209.545 136.66 209.545C115.401 209.545 98.168 194.563 98.168 176.087V154.176C98.168 172.652 115.401 185.858 136.66 185.858C157.92 185.858 175.152 172.652 175.152 154.176Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.152 177.656V199.567C175.152 218.043 157.92 233.026 136.66 233.026C115.401 233.026 98.168 218.043 98.168 199.567V177.656C98.168 196.132 115.401 209.338 136.66 209.338C157.92 209.338 175.152 196.132 175.152 177.656Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.152 124.563V154.172C175.152 172.649 157.92 185.854 136.66 185.854C115.401 185.854 98.168 172.649 98.168 154.172V124.563C98.168 106.087 115.401 91.1045 136.66 91.1045C147.32 91.1045 156.913 94.8353 163.901 100.876C170.829 106.975 175.152 115.325 175.152 124.563Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.152 124.563C175.152 129.952 173.672 134.926 171.066 139.19C164.73 149.613 151.702 156.245 136.66 156.245C121.619 156.245 108.59 149.613 102.254 139.19C99.6485 134.926 98.168 129.952 98.168 124.563C98.168 115.325 102.491 106.975 109.419 100.935C116.407 94.8353 126.001 91.1045 136.66 91.1045C147.32 91.1045 156.913 94.8353 163.901 100.876C170.829 106.975 175.152 115.325 175.152 124.563Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.163 236.457C167.172 239.047 173.016 240.519 179.347 240.519L189.954 240.519L192.687 163.991C192.687 163.991 190.2 163.99 179.347 163.99C173.016 163.99 167.172 165.462 162.163 168.052C149.918 174.351 142.126 187.302 142.126 202.255C142.126 217.207 149.918 230.158 162.163 236.457Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.278 240.519C183.947 240.519 178.103 239.047 173.094 236.457C160.849 230.158 153.057 217.207 153.057 202.255C153.057 187.302 160.849 174.351 173.094 168.052C178.103 165.462 183.947 163.99 190.278 163.99C201.131 163.99 210.941 168.288 218.037 175.175C225.203 182.122 229.586 191.658 229.586 202.255C229.586 212.851 225.203 222.388 218.107 229.334C210.941 236.222 201.131 240.519 190.278 240.519Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3887 152.075L43.7354 149.524C42.6918 149.176 41.0683 149.408 40.1793 150.065L34.7872 153.911C31.3278 156.366 28.5062 154.935 28.5062 150.684L28.5061 143.494C28.5061 142.296 27.6751 140.769 26.6315 140.112L21.1427 136.672C16.8136 133.966 17.3161 130.72 22.2637 129.444L29.1633 127.685C30.4195 127.357 31.695 126.081 32.0235 124.825L33.7823 117.925C35.0578 112.978 38.3047 112.475 41.0104 116.804L44.4504 122.293C45.0882 123.317 46.615 124.148 47.8326 124.168L55.022 124.168C59.2738 124.168 60.7234 127.009 58.2496 130.449L54.4036 135.841C53.7658 136.749 53.5145 138.353 53.8624 139.397L56.4135 147.05C57.805 151.186 55.5245 153.467 51.3887 152.075Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7762 136.247L77.3047 149.775",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5848 159.438L54.1133 172.967",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8417 157.506L65.707 161.371",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M195.272 63.5438L198.427 54.0804C198.857 52.79 198.57 50.7826 197.758 49.6833L193.002 43.0159C189.967 38.7382 191.736 35.2493 196.993 35.2493L205.883 35.2492C207.364 35.2492 209.252 34.2217 210.065 32.9312L214.319 26.1442C217.664 20.7912 221.679 21.4126 223.256 27.5303L225.431 36.0618C225.837 37.6151 227.414 39.1923 228.968 39.5985L237.499 41.7733C243.617 43.3505 244.238 47.3653 238.885 50.7109L232.098 54.9646C230.832 55.7532 229.804 57.6411 229.78 59.1467L229.78 68.0365C229.78 73.2939 226.267 75.0863 222.014 72.0274L215.346 67.2718C214.223 66.4832 212.24 66.1725 210.949 66.6027L201.486 69.7571C196.372 71.4777 193.552 68.6579 195.272 63.5438Z",
    fill: "#0008C3",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M214.845 78.8616L198.117 95.5898",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M186.17 50.1849L169.441 66.9131",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M188.557 76.4725L183.777 81.252",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyLogoBig);
export default __webpack_public_path__ + "static/media/moneyLogoBig.817594b431de9c6f2ceafb6c2e14c3a7.svg";
export { ForwardRef as ReactComponent };